function associationLine(item) {
  const warning = item.compatibile === false ? " [nome da verificare]" : "";
  if (item.tipo === "nuovo_centro") {
    return `• CF ${item.codice_fiscale} · nuovo CC2 ${item.codice_cc2} per "${item.cliente_principale}"`;
  }
  return `• CF ${item.codice_fiscale}: "${item.denominazione}" sarà associata a "${item.cliente_principale}"${warning}`;
}

export function isClientRegistryConfirmation(error) {
  return (
    error?.response?.status === 409 &&
    error?.response?.data?.code === "CLIENT_REGISTRY_CONFIRMATION_REQUIRED"
  );
}

export function confirmClientRegistryAssociations(error, onConfirm) {
  if (!isClientRegistryConfirmation(error)) return false;
  const associations = error.response?.data?.associations || [];
  const lines = associations.map(associationLine).join("\n");
  const hasWarnings = associations.some((item) => item.compatibile === false);
  const warning = hasWarnings
    ? "\n\nAlmeno una denominazione non risulta simile a quelle già note: controllala con attenzione."
    : "";
  window.dispatchEvent(
    new CustomEvent("client-registry-confirmation-request", {
      detail: {
        message: `Nuove associazioni anagrafiche rilevate\n\n${lines}${warning}\n\nContinuando verranno registrate senza creare clienti duplicati.`,
        onConfirm,
      },
    })
  );
  return true;
}
